import React from 'react';
import ReactDOM from 'react-dom/client';
import AntikytheraDevice from './components/antikythera/AntikytheraDevice';
import './styles/design-system.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AntikytheraDevice />
  </React.StrictMode>
);
